module.exports = __webpack_public_path__ + "img/39_004_012.51289dc9.png";